<template>
  <div
    class="mb-16 base-card-wrapper">
    <div style="height: inherit;" class="sub-card-wrapper">
      <BaseListItemCard
        :class="[active ,'green-1-b']"
        style="height:inherit" size="sm">
        <div style="height: inherit" class="flex flex-col">
          <div style="margin-top: 15px" class="flex items-start justify-between mb-2 w-full">
            <div class="flex items-center w-full">
              <div class="flex flex-col w-full">
                <div class="flex justify-between w-full">
                  <h3 class="grey-4-color text-base-span-md">{{ name }}</h3>
                  <InlineSvg
                    v-if="active"
                    src="/img/check.svg"
                    class="green-5-color h-5"
                  ></InlineSvg>
                </div>
                <span class="mt-6 text-base-span-sm grey-3-color">Роль: {{ role }}</span>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 15px" class="mt-6">
            <p class="text-sm grey-3-color">
              {{ $t("contract.user.added") }}: {{ joinDate }}
            </p>
          </div>
        </div>
      </BaseListItemCard>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    joinDate: {
      type: [String, Date],
      required: true
    }
  },
  computed: {}
};
</script>
